(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-review-slider')) {
    customElements.define('ds-review-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        const go = (i) => this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
        const current = () => Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.querySelector('[data-prev]')?.addEventListener('click', () => go(Math.max(0, current() - 1)));
        this.querySelector('[data-next]')?.addEventListener('click', () => go((current() + 1) % this.dots.length));
        this.dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
        this.track.addEventListener('scroll', () => {
          const c = current();
          this.dots.forEach((d, i) => d.classList.toggle('is-active', i === c));
        }, { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
